import React, { createContext, useContext, useEffect, useState } from "react";
import { useLoadScript } from "@react-google-maps/api";
import axiosConfig from "../utils/axiosConfig";
const GoogleMapsContext = createContext(null);
const libraries = ["places"];
export const GoogleMapsProvider = ({ children }) => {
  const [apiKey, setApiKey] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const fetchKey = async () => {
      try {
        const res = await axiosConfig.get("/masters/googlemapkey/");
        const key = res?.data?.results?.[0]?.key;
        if (key) {
          setApiKey(key);
          setReady(true);
        }
      } catch (error) {
        console.error("Failed to fetch Google Maps key:", error);
      }
    };

    fetchKey();
  }, []);

 
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey || "", 
    libraries,
  });

  return (
    <GoogleMapsContext.Provider
      value={{
        isLoaded: ready && isLoaded,
        loadError,
      }}
    >
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);